/** @flow */
import * as React from 'react';
import {AutoSizer, MultiGrid} from 'react-virtualized';
import { MatrixViewDataAsync, MatrixViewItemsAsync, GetDataStoredInDataset } from './fetchData';
import cn from 'classnames'
import { Loading } from './Loading';
import DetailWindow from './DetailWindow';
import TitleWindow from './TitleWindow';
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"
import {PageView} from '../components/Tracking';
import Draggable from "react-draggable"
import { deepmerge } from "./isMergeableObject"

export default class MatrixView extends React.PureComponent {

constructor(props) {
	super(props);
	const viewID = props.match.params.id
	const datasetID = props.match.params.datasetID
	const Note = props.location.state.ViewNote
	const FieldArray = props.location.state.FieldArray
	const DetailFields = props.location.state.DetailFields
	const TitleViewField = props.location.state.TitleViewField
	const appURL = props.location.state.appURL
	let DetailViews = [];
	let numDetails = 0;
	let DetailWindowsPanelClass = ""
	if (props.location.state.DetailViews !== ""){
		DetailViews = props.location.state.DetailViews;
		numDetails = DetailViews.length
	}
	if (numDetails === 0){
		DetailWindowsPanelClass = cn("zero-width")
	}

	this.state = {
		matrixItems: {},
		DetailWindowsPanelClass: DetailWindowsPanelClass,
		MatrixHeader: '',
		RecordsSelectedInDetailView: [],
		RowFieldName: '',
		ColFieldName: '',
		appURL: appURL,
		FloodMin: 0,
		FloodMax: 1,
		widths: {},
		Groups: [],
		numDetails: numDetails,
		MatrixName: '',
		datasetID: datasetID,
		matrixViewID: viewID,
		TitleViewField: TitleViewField,
		FieldArray, FieldArray,
		DetailFields, DetailFields,
		loading: true,
		columnCount: 4,
		overscanColumnCount: 25,
		overscanRowCount: 50,
		row_heights: {},
		rowCount: 1,
		scrollToColumn: undefined,
		scrollToRow: undefined,
		useDynamicRowHeight: false,
		fixedColumnCount: 3,
		fixedRowCount: 3,
		ColumnSortOrder: {},
		ColumnSortArray: [],
		RowSortOrder: {},
		RowSortArray: [],
		selectedRows: [],
		selectedCols: [],
		selectedItems: [],
		FloodIncrement: 1,
		parseType: "Int",
		WebsiteURL: "https://www.thevantagepoint.com/",
		mainPanelSelection: [],
		sheetNote: Note,
		HeatMap: {
			Red: 136,
			Green: 146,
			Blue: 212
		},
		DetailViews: DetailViews,
	};

	this._cellRenderer = this._cellRenderer.bind(this);
	this._getRowClassName = this._getRowClassName.bind(this);
	this._noContentRenderer = this._noContentRenderer.bind(this);
	this._onColumnCountChange = this._onColumnCountChange.bind(this);
	this._onRowCountChange = this._onRowCountChange.bind(this);
	this._onScrollToColumnChange = this._onScrollToColumnChange.bind(this);
	this._onScrollToRowChange = this._onScrollToRowChange.bind(this);
	this._renderBodyCell = this._renderBodyCell.bind(this);
	this.ResetMatrix = this.ResetMatrix.bind(this);
	this.sortColumn = this.sortColumn.bind(this);
	this.sortRow = this.sortRow.bind(this);
	this.resizeColumn = this.resizeColumn.bind(this);
	this.resizeRow = this.resizeRow.bind(this);
	this.handleChange = this.handleChange.bind(this);
	this.AdjustCeiling = this.AdjustCeiling.bind(this);
	this.AdjustFloor = this.AdjustFloor.bind(this);
}
  
fetchData(appURL, datasetID, matrixViewID){
	MatrixViewDataAsync(appURL, datasetID, matrixViewID, this.abortController.signal)
	.then((data) => {
		const reducer = function (accumulator, currentValue) {
			let currentKeys = Object.keys(currentValue);
			if (currentKeys.indexOf("RName0") === -1 && currentKeys.indexOf("CName0") === -1 && currentKeys.indexOf("RRecs0") === -1 && currentKeys.indexOf("CRecs0") === -1){
				return Object.values(accumulator).concat(Object.values(currentValue));
			}
			else  {
				return Object.values(accumulator)
			}
		}
		let parseType = "Int";
		let FloodIncrement = 1;
		let FloodMin = Number(data.FloodMin);
		let FloodMax = Number(data.FloodMax);
		if (data.MatrixHeader.indexOf('Correlation') >= 0 || data.MatrixHeader.indexOf('TFIDF') >= 0){
			parseType = "Float";
			FloodIncrement = 0.05;
			FloodMin = FloodMin.toFixed(2);
			FloodMax = FloodMax.toFixed(2);
		}
		var RowOrderArray = [];
		for (var i=0; i<data.RowCount; i++){
			RowOrderArray.push(i);
		}
		var ColOrderArray = [];
		for (var i=0; i<data.ColCount; i++){
			ColOrderArray.push(i);
		}
		
		let colArr = new Array(data.ColCount)
		let rowArr = new Array(data.RowCount)
		let RowCount = data.RowCount + 3
		let ColumnCount = data.ColCount + 3
		colArr.fill(40, 0, data.ColCount)
		rowArr.fill(20, 0, data.RowCount)
		let widths = [40, 40, 400, 40].concat(colArr)
		let row_heights = [20, 20, 100, 20].concat(rowArr)
		if (this.mounted){

			this.setState({
				MatrixName: data.Name,
				MatrixHeader: data.MatrixHeader,
				RowFieldName: data.RowFieldName,
				ColFieldName: data.ColFieldName,
				widths: widths,
				row_heights: row_heights,
				loading: true,
				LowerFlood: FloodMin,
				UpperFlood: FloodMax,
				FloodIncrement: FloodIncrement,
				ColumnSortArray: ColOrderArray,
				RowSortArray: RowOrderArray,
				parseType: parseType,
			})
		}
		let MatrixBlocks = 100
		let Blocks = 1;
		let FullMatrixData = {}
		let myTimeout = setTimeout(() => {
			for (var index = 0; index < data.RowCount; index += MatrixBlocks) {
				for (var colIndex = 0; colIndex < data.ColCount; colIndex += MatrixBlocks) {
					MatrixViewItemsAsync(appURL, datasetID, matrixViewID, index, colIndex, this.abortController.signal).then((MatrixItems) => {
						if (FullMatrixData !== {}){
							FullMatrixData = deepmerge(FullMatrixData, MatrixItems)
						}
						else {
							FullMatrixData = MatrixItems
						}
						let temps = Object.values(FullMatrixData).slice(1, Object.values(FullMatrixData).length - 1)
						let myObjtemp = temps.reduce(reducer)
						//let myObj = flatten(Object.values(data.Matrix).slice(1, Object.values(data.Matrix).length - 1).reduce(reducer))
						//const NumberArray = myObjtemp.map(Number)
						const NumberArray = Object.values(myObjtemp) //this may only work when there is 1 and only 1 row
						const MaxFlood = NumberArray.reduce(function(a, b) {
							return Math.max(a, b);
						});
						const MinFlood = NumberArray.reduce(function(a, b) {
							return Math.min(a, b);
						});
						let matrixLength = Object.keys(FullMatrixData).length + 1
						if (matrixLength === RowCount){
							if (this.mounted){
								this.setState({
									matrixItems: FullMatrixData,
									rowCount: RowCount,
									columnCount: ColumnCount,
									FloodMin: MinFlood,
									FloodMax: MaxFlood,
									loading: false
								})
							}
						}

						
					})
				}
			}
		}, Blocks)
	})
}
	componentDidMount(){
		this.mounted = true;
		this.fetchData(this.state.appURL, this.state.datasetID, this.state.matrixViewID)
		PageView()
	}
	componentDidUpdate(prevProps, prevState){
		//Get last 16 characters to get the matrix id. 
		let ViewID = String(prevProps.history.location.pathname).substring(String(prevProps.history.location.pathname).length - prevProps.match.params.id.length)
		if (this.state.widths !== prevState.widths){
			//this._multigrid.forceUpdateGrids();
		}
		if (prevProps.location.pathname !== prevProps.history.location.pathname){
			let DetailViews = [];
			let numDetails = 0;
			let DetailWindowsPanelClass = ""
			if (this.props.location.state.DetailViews !== ""){
				DetailViews = this.props.location.state.DetailViews;
				numDetails = DetailViews.length

			}
			if (numDetails === 0){
				DetailWindowsPanelClass = cn("zero-width")
			}
			if (this.mounted){
				this.setState({
					matrixItems: {},
					DetailWindowsPanelClass: DetailWindowsPanelClass,
					Groups: [],
					MatrixName: '',
					rowCount: 0,
					columnCount: 0,
					matrixViewID: ViewID,
					loading: true,
					sheetNote: this.props.location.state.ViewNote,
					mainPanelSelection: [],
					numDetails: numDetails,
					row_heights: {},
					widths: {},
					DetailViews: DetailViews
				})
				
				this.fetchData(this.state.appURL, this.state.datasetID, ViewID)
			}
		}

	}
	componentWillUnmount(){
		this.mounted = false;
		this.abortController.abort();
	}
	abortController = new window.AbortController();
	columnWidthGetter = column => {
		let widths = { ...this.state.widths };
		return widths[column]
	};
	rowHeightGetter = row => {
		let row_heights = { ...this.state.row_heights };
		return row_heights[row]
	};

	onDragStop = () => {
		this._multigrid.recomputeGridSize();
	};

	resizeCol = ({ columnIndex, deltaX }) => {
		this.setState(prevState => {
			const prevWidths = prevState.widths;

			return {
				widths: {
					...prevWidths,
					[columnIndex]: Math.max(0.15, prevWidths[columnIndex] + deltaX)
				}
			};
		});
	};
  
	resizeRow = ({ rowIndex, deltaY }) => {
		this.setState(prevState => {
			const prevHeights = prevState.row_heights;

			return {
				row_heights: {
					...prevHeights,
					[rowIndex]: Math.max(0.15, prevHeights[rowIndex] + deltaY)
				}
			};
		});
	};
  ResetMatrix(){
	var RowOrderArray = [];
	const rows = this.state.rowCount - 3;
	const cols = this.state.columnCount - 3;
	let colArr = new Array(cols)
	let rowArr = new Array(rows)
	colArr.fill(40, 0, cols)
	rowArr.fill(20, 0, rows)
	let widths = [40, 40, 400, 40].concat(colArr)
	let row_heights = [20, 20, 100, 20].concat(rowArr)
	const lowerFlood = this.state.FloodMin;
	const upperFlood = this.state.FloodMax;
	for (var i=0; i<rows; i++){
	  RowOrderArray.push(i);
	}
	var ColOrderArray = [];
	for (var i=0; i<cols; i++){
	  ColOrderArray.push(i);
	}
	this.setState({
		LowerFlood: lowerFlood,
		UpperFlood: upperFlood,
		ColumnSortArray: ColOrderArray,
		RowSortArray: RowOrderArray,
		selectedRows: [],
		selectedCols: [],
		selectedItems: [],
		widths: widths,
		row_heights: row_heights,
		RecordsSelectedInDetailView: [],
	})
	this._multigrid.recomputeGridSize();
	this._multigrid.forceUpdateGrids();
  }
  resizeColumn(column, { deltaX }){
	const newArray = this.state.widths.map(function(val, index) {
	  if (index === column){
		return (val + deltaX)
		}
		else {
		  return (val)
		}
	  })
	this.setState({
		widths: newArray
	});
  }
  resizeRow(row, { deltaY }){
	const newArray = this.state.row_heights.map(function(val, index) {
	  if (index === row){
		return (val + deltaY)
		}
		else {
		  return (val)
		}
	  })
	this.setState({
		row_heights: newArray
	});
  }

sortRow(row){
  var currentSort = this.state.RowSortOrder;
  var newSortOrder = "desc"
  var sortedList
  if (currentSort.Row === row && currentSort.Order === "desc"){
	newSortOrder = "asc"
  }
  const unsortedList = this.state.matrixItems
  let SortedMatrix;
  switch (row){
	case 1:
	  SortedMatrix = sortObject(unsortedList.ColLabels, "CRecs", newSortOrder)
	  break;
	case 2:
	  SortedMatrix = sortObject(unsortedList.ColLabels, "CName", newSortOrder)
	  break;
	default:
	  var rowToSort = row - 3;
	  SortedMatrix = sortObjectRow(unsortedList, "R" + this.state.RowSortArray[rowToSort], newSortOrder, this.state.parseType, this.state.columnCount)
	  break;

	}
	this.setState({
		RowSortOrder: {"Row": row, "Order": newSortOrder},
		ColumnSortArray: SortedMatrix,
		selectedRows: []
	})
}

sortColumn(column){
  var currentSort = this.state.ColumnSortOrder;
  var newSortOrder = "desc"
  var sortedList
  if (currentSort.Column === column && currentSort.Order === "desc"){
	newSortOrder = "asc"
  }
  const unsortedList = this.state.matrixItems
  let SortedMatrix;
  switch (column){
	case 1:
	  SortedMatrix = sortObject(unsortedList.RowLabels, "RRecs", newSortOrder)
	  break;
	case 2:
	  SortedMatrix = sortObject(unsortedList.RowLabels, "RName", newSortOrder)
	  break;
	default:
	  var colToSort = column - 3;
	  SortedMatrix = sortObjectColumn(unsortedList, "C" + this.state.ColumnSortArray[colToSort], newSortOrder, this.state.parseType)
	  break;
  
  }
  
  this.setState({
	//RowSortArray: RowOrder,
	ColumnSortOrder: {"Column": column, "Order": newSortOrder},
	RowSortArray: SortedMatrix,
	selectedRows: []
  })
	  
}
handleChange(event) {
  //console.log(event)
}

selectItem = (row, column, event) => {
  var rowIndex = row - 3
  var colIndex = column - 3

  const selectIndex = '(' + this.state.RowSortArray[rowIndex] + ',' + this.state.ColumnSortArray[colIndex] + ')'
  if (event.ctrlKey){
	//concatentate
	var selectedRows = this.state.selectedRows;
	var selectedCols = this.state.selectedCols;
	var selectedItems = this.state.selectedItems.concat({row, column});
	var mainPanelSelection = {
	  bSelection: true,
	  selectedIDs: this.state.mainPanelSelection.selectedIDs.concat(selectIndex)
	}
  }
  else if (event.shiftKey){
	//loop and concatenate
	var initialRow = this.state.InitialRowCol.row;
	var initialCol = this.state.InitialRowCol.column;
	var selectedIDs = this.state.mainPanelSelection.selectedIDs;
	var selectedItems = this.state.selectedItems;
	if (initialRow < row){
	  if (initialCol < column){

		for (var i=initialRow; i<=row; i++){
		  for (var y=initialCol; y<=column; y++){
			selectedItems = selectedItems.concat([{row: i, column: y}])
			rowIndex = i - 3;
			colIndex = y - 3;
			selectedIDs = selectedIDs.concat('(' + this.state.RowSortArray[rowIndex] + ',' + this.state.ColumnSortArray[colIndex] + ')');
		  }
		}
	  }
	  else {        
		for (var i=initialRow; i<=row; i++){
		  for (var y=initialCol; y>=column; y--){
			selectedItems = selectedItems.concat([{row: i, column: y}])
			rowIndex = i - 3;
			colIndex = y - 3;
			selectedIDs = selectedIDs.concat('(' + this.state.RowSortArray[rowIndex] + ',' + this.state.ColumnSortArray[colIndex] + ')');
		  }
		}

	  }
	}
	else {
	  if (initialCol < column){

		for (var i=initialRow; i>=row; i--){
		  for (var y=initialCol; y<=column; y++){
			selectedItems = selectedItems.concat([{row: i, column: y}])
			rowIndex = i - 3;
			colIndex = y - 3;
			selectedIDs = selectedIDs.concat('(' + this.state.RowSortArray[rowIndex] + ',' + this.state.ColumnSortArray[colIndex] + ')');
		  }
		}
	  }
	  else {       
		for (var i=initialRow; i>=row; i--){
		  for (var y=initialCol; y>=column; y--){
			selectedItems = selectedItems.concat([{row: i, column: y}])
			rowIndex = i - 3;
			colIndex = y - 3;
			selectedIDs = selectedIDs.concat('(' + this.state.RowSortArray[rowIndex] + ',' + this.state.ColumnSortArray[colIndex] + ')');
		  }
		}
		
	  }
	}
	var mainPanelSelection = {
	  bSelection: true,
	  selectedIDs: this.state.mainPanelSelection.selectedIDs.concat(selectedIDs)
	}
	var selectedRows = this.state.selectedRows;
	var selectedCols = this.state.selectedCols;
  }
  else {

	var mainPanelSelection = {
	  bSelection: true,
	  selectedIDs: [selectIndex]
	}
	var selectedRows = [];
	var selectedCols = [];
	var selectedItems = [{row, column}];
  }
  this.setState({
	mainPanelSelection: mainPanelSelection,
	selectedItems: selectedItems,
	selectedRows: selectedRows,
	selectedCols: selectedCols,
	InitialRowCol: {row, column}
  });
}
selectRow = (row, event) => {
  const selectIndex = row - 3
  if (event.ctrlKey){

	var mainPanelSelection = {
	  bSelection: true,
	  selectedIDs: this.state.mainPanelSelection.selectedIDs.concat('Row' + this.state.RowSortArray[selectIndex]),
	}
	this.setState({
	  mainPanelSelection: mainPanelSelection,
	  selectedRows: this.state.selectedRows.concat(row)
	});
  }
  else {
	var mainPanelSelection = {
	  bSelection: true,
	  selectedIDs: ['Row' + this.state.RowSortArray[selectIndex]],
	}
	this.setState({
	  mainPanelSelection: mainPanelSelection,
	  selectedItems: [],
	  selectedRows: [row],
	  selectedCols: []
	});
  }
}
selectColumn = (column, event) => {
  const selectIndex = column - 3
  if (selectIndex >= 0){
	if (event.ctrlKey){
	  var mainPanelSelection = {
		bSelection: true,
		selectedIDs: this.state.mainPanelSelection.selectedIDs.concat('Col' + this.state.ColumnSortArray[selectIndex]),
	  }
	  this.setState({
		mainPanelSelection: mainPanelSelection,
		selectedCols: this.state.selectedCols.concat(column)
	  });
	}
	else {
	  const mainPanelSelection = {
		bSelection: true,
		selectedIDs: ['Col' + this.state.ColumnSortArray[selectIndex]]
	  }
	  this.setState({
		mainPanelSelection: mainPanelSelection,
		selectedItems: [],
		selectedRows: [],
		selectedCols: [column]
	  });
	}
  }
  else {
	const mainPanelSelection = {
	  bSelection: false,
	  selectedIDs: []
	}
	this.setState({
	  mainPanelSelection: mainPanelSelection,
	  selectedItems: [],
	  selectedRows: [],
	  selectedCols: []
	});
  }
}

getDetailSelection = (dataFromChild) => {
  this.setState({
	RecordsSelectedInDetailView: dataFromChild
  })
 }


  render() {
	const {
		widths,
		columnCount,
		overscanColumnCount,
		overscanRowCount,
		height,
		row_heights,
		rowCount,
		DetailViews,
		matrixViewID,
		datasetID,
		mainPanelSelection,
		WebsiteURL,
		TitleViewField,
		FieldArray,
		DetailFields,
		appURL,
		DetailWindowsPanelClass
	} = this.state;
	return (
	  <div className="FillWindow">
		{this.state.loading === true
		? <Loading />
		:<div >
		<div className="flex-grid">
		  <div className="TitleWindowPanel">
			<TitleWindow appURL={appURL} id={matrixViewID} datasetID={this.state.datasetID} mainPanelSelection={mainPanelSelection} detailSelection={this.state.RecordsSelectedInDetailView} Note={this.state.sheetNote} callbackFromParent={this.getTitleSelection} DefaultField={TitleViewField} FieldArray={FieldArray}></TitleWindow>
		  </div>
		  <div className="MainPanel">

		<AutoSizer>
		  {({width, height}) => (
			<MultiGrid
				{...this.state}
				widths={widths}
				row_heights={row_heights}
				ref={(ref) => this._multigrid = ref}
				cellRenderer={this._cellRenderer}
				className={"BodyGrid"}
				columnWidth={({index}) => {
					return widths[index]
				}}
				rowHeight={({index}) => {
				return row_heights[index]
				}}
				columnCount={columnCount}
				height={height}
				noContentRenderer={this._noContentRenderer}
				overscanColumnCount={overscanColumnCount}
				overscanRowCount={overscanRowCount}
				rowCount={rowCount}
				width={width}>
			</MultiGrid>
		  )}
		</AutoSizer>
		  </div>

			<div className={cn(DetailWindowsPanelClass, "DetailWindowPanel")}>
				{DetailViews.map((value, num) => {
					return (
						<DetailWindow appURL={appURL} key={num} id={matrixViewID} numDetails={this.state.numDetails} datasetID={datasetID} mainPanelSelection={mainPanelSelection} DefaultField={value} callbackFromParent={this.getDetailSelection} FieldArray={FieldArray} DetailFields={DetailFields}></DetailWindow>
					)
				})}
			</div>
		  </div>
		</div>
		}
	  </div>
	);
  }

  _cellRenderer({columnIndex, key, rowIndex, style}) {
	if (rowIndex <= 2 || columnIndex <= 2){
	  return this._renderHeaderCell({columnIndex, key, rowIndex, style});
	}
	else {
	  return this._renderBodyCell({columnIndex, key, rowIndex, style});
	}
  }  


  _getRowClassName(row) {
	return row % 2 === 0 ? "evenRow" : "oddRow";
  }

  _noContentRenderer() {
	return <div className="noCells">No cells</div>;
  }

  _renderHeaderCell({columnIndex, key, rowIndex, style}) {
	let classNames = cn("cell", "HeaderRow", "OddRow")
	if (rowIndex % 2 === 0){
		classNames = cn("cell", "HeaderRow", "EvenRow");
	}
	const centerTextClass = cn("cell", "HeaderRow", "centerText");
	let content;
	var colToGet = columnIndex - 3;
	var rowToGet = rowIndex - 3;
	style = {
		...style,
		width: this.columnWidthGetter(columnIndex),
		height: this.rowHeightGetter(rowIndex)
	};
	if (rowIndex === 0){

	  switch (columnIndex) {
		case 0:
		  return (
			<div className={classNames} key={key} style={style} onClick={() => this.ResetMatrix()}><span>Reset</span></div>
		  );
		case 1:
		  return (
			<div className={cn(centerTextClass, "sortDown")} key={key} style={style} onDoubleClick={() => this.sortColumn(columnIndex)}></div>
		  );
		case 2:
		  content = <div>{this.state.RowFieldName}<span className="float-right DragHandleIcon">::</span></div>;
		  break;
		default:
		  content = <div>{columnIndex - 2}<span className="float-right DragHandleIcon">::</span></div>;
		  break;
	  }
	}
	else if(rowIndex === 1){
	  switch (columnIndex) {
		case 0:
		  return (
			<div className={cn(classNames, "sortRight")} key={key} style={style} onDoubleClick={() => this.sortRow(rowIndex)}></div>
		  );
		case 1:
		  return (
			<div className={classNames} key={key} style={style}></div>
		  );
		case 2:
		  content = <span># Records</span>;
		  break;
		default:
		  content = this.state.matrixItems.ColLabels["CRecs" + this.state.ColumnSortArray[colToGet]]
		  break;
	  }
	}
	else if(rowIndex === 2){
	  switch (columnIndex) {
		case 0:
		  content = <div title={this.state.ColFieldName} className="rotate rotate-matrix" onDoubleClick={() => this.sortRow(rowIndex)}><span className="float-top DragHandleRow"></span>{this.state.ColFieldName}</div>;
		  break;
		case 1:
		  content = <div className="rotate rotate-matrix"># Records</div>;
		  break;
		case 2:
		  content = <div style={{width:"100%"}}><div className="upperButtonContainer"><div className="iconContainer" onClick={() => this.AdjustCeiling('DOWN')}><div className="downArrowIcon LowerCeiling"></div></div><div className="iconContainer" onClick={() => this.AdjustCeiling('UP')}><div className="upArrowIcon RaiseCeiling"></div></div></div><div className="textContainer">Show Values &gt;= {this.state.LowerFlood} and 	&lt;= {this.state.UpperFlood}</div><div className="textContainer">{this.state.MatrixHeader}</div><div className="lowerButtonContainer"><div className="iconContainer" onClick={() => this.AdjustFloor('DOWN')}><div className="downArrowIcon LowerFloor"></div></div><div className="iconContainer" onClick={() => this.AdjustFloor('UP')}><div className="upArrowIcon RaiseFloor"></div></div></div></div>;
		  break;
		default:
		  content = <div title={this.state.matrixItems.ColLabels["CName" + this.state.ColumnSortArray[colToGet]]} className="rotate rotate-matrix">{this.state.matrixItems.ColLabels["CName" + this.state.ColumnSortArray[colToGet]]}</div>;
		  break;
	  }
	}
	else {
	  switch (columnIndex) {
		case 0:
		  content = <div>{rowIndex - 2}<span className="float-bottom DragHandleRow"></span></div>;
		  break;
		case 1:
		  content = <span title={this.state.matrixItems.RowLabels["RRecs" + this.state.RowSortArray[rowToGet]]} >{this.state.matrixItems.RowLabels["RRecs" + this.state.RowSortArray[rowToGet]]}</span>
		  break;
		case 2:
		  content = <span title={this.state.matrixItems.RowLabels["RName" + this.state.RowSortArray[rowToGet]]} >{this.state.matrixItems.RowLabels["RName" + this.state.RowSortArray[rowToGet]]}</span>
		  break;
		default:
		  break;
	  }}
	  if (rowIndex === 0){

		return (
			<div className={cn(centerTextClass, "sortDown")} key={key} style={style} onDoubleClick={() => this.sortColumn(columnIndex)}>
				<Draggable
					axis="x"
					defaultClassNameDragging="DragHandleActive"
					onDrag={(event, {deltaX}) => {
						this.resizeCol({columnIndex, deltaX});
					}}
					onStop={this.onDragStop}
					position={{x:0}}
					zIndex={999}
				>
				{content}
				</Draggable>
			</div>
	  );
	}    
	else if (rowIndex <= 2){
		if (columnIndex === 2){
			return (
				<div className={classNames} key={key} style={style} onMouseDown={this.selectColumn.bind(this, columnIndex)} >
					{content}
				</div>
			);
		}
		else if (rowIndex === 2 && columnIndex === 0){
			return (
				<div className={cn(centerTextClass, "sortRight")} key={key} style={style} onMouseDown={this.selectColumn.bind(this, columnIndex)} >
					<Draggable
						axis="y"
						defaultClassNameDragging="DragHandleActive"
						onDrag={(event, {deltaY}) => {
							this.resizeRow({rowIndex, deltaY});
						}}
						onStop={this.onDragStop}
						position={{x:0}}
						zIndex={999}
					>
						{content}
					</Draggable>
				</div>
			);
		}
		else {
			return (
				<div className={centerTextClass} key={key} style={style} onMouseDown={this.selectColumn.bind(this, columnIndex)} >
					{content}
				</div>
			);
		}	
	}
	else if (columnIndex === 0){
	  return (
		<div className={cn(classNames, "sortRight")} key={key} style={style} onDoubleClick={() => this.sortRow(rowIndex)}>
			<Draggable
					axis="y"
					defaultClassNameDragging="DragHandleActive"
					onDrag={(event, {deltaY}) => {
						this.resizeRow({rowIndex, deltaY});
					}}
					onStop={this.onDragStop}
					position={{x:0}}
					zIndex={999}
				>
					{content}
			</Draggable>
		</div>
	);
	}
	else if (columnIndex <= 2){
	  return (
		<div className={classNames} key={key} style={style} onMouseDown={this.selectRow.bind(this, rowIndex)} >
		{content}
	  </div>
	);
	}

	else {
	  return (
		<div title={content} className={classNames} key={key} style={style}>

		{content}
		</div>
	  );
	}
  } 
  _renderBodyCell({columnIndex, key, rowIndex, style}) {
	const rowClass = this._getRowClassName(rowIndex - 1);
	let content;
	let isSelected;
	var colToGet = columnIndex - 3;
	var rowToGet = rowIndex - 3;
	let alphaVal = 0;
	style = {
		...style,
		width: this.columnWidthGetter(columnIndex),
		height: this.rowHeightGetter(rowIndex)
	};

	if (this.state.selectedRows.indexOf(rowIndex) >= 0){
	  isSelected = true;
	}
	else if (this.state.selectedCols.indexOf(columnIndex) >=0){
	  isSelected = true;
	}
	else if (this.state.selectedItems){
	  let elem = this.state.selectedItems.find(o => o.row === rowIndex && o.column === columnIndex)
	  if (elem) {
		isSelected = true;
	  }
	  else {
		isSelected = false;
	  }
	}
	else {
	  isSelected = false;
	}
	const classNames = cn(rowClass, "cell", "centerText", {
		"selected": isSelected
	},
	{"EvenRow": rowIndex % 2 === 0});
	var rowData = ""
	if (this.state.matrixItems.hasOwnProperty("R" + this.state.RowSortArray[rowToGet])){
		rowData = this.state.matrixItems["R" + this.state.RowSortArray[rowToGet]]
	}
	if (rowData === "" || typeof(rowData["C" + this.state.ColumnSortArray[colToGet]]) == 'undefined'){
	  content = "";
	}
	else {
		content = Number(rowData["C" + this.state.ColumnSortArray[colToGet]]);
	  if (content > this.state.UpperFlood || content < this.state.LowerFlood){
			content = "";
		}
		else {
			alphaVal = parseFloat(Math.log(content) / Math.log(this.state.FloodMax).toPrecision(2)) 
		}
		style = {
			...style,
			backgroundColor: 'rgba(' + this.state.HeatMap.Red + ',' + this.state.HeatMap.Green + ',' + this.state.HeatMap.Blue + ',' + alphaVal + ')',

		}
	}
	  return (
		<div className={classNames} key={key} style={style} onMouseDown={this.selectItem.bind(this, rowIndex, columnIndex)}>
		{content}
	  </div>
	);
  }

  _updateUseDynamicRowHeights(value) {
	this.setState({
	  useDynamicRowHeight: value,
	});
  }

  _onColumnCountChange(event) {
	const columnCount = parseInt(event.target.value, 10) || 0;

	this.setState({columnCount});
  }

  _onRowCountChange(event) {
	const rowCount = parseInt(event.target.value, 10) || 0;

	this.setState({rowCount});
  }

  _onScrollToColumnChange(event) {
	const {columnCount} = this.state;
	let scrollToColumn = Math.min(
	  columnCount - 1,
	  parseInt(event.target.value, 10),
	);

	if (isNaN(scrollToColumn)) {
	  scrollToColumn = undefined;
	}

	this.setState({scrollToColumn});
  }

  _onScrollToRowChange(event) {
	const {rowCount} = this.state;
	let scrollToRow = Math.min(rowCount - 1, parseInt(event.target.value, 10));

	if (isNaN(scrollToRow)) {
	  scrollToRow = undefined;
	}

	this.setState({scrollToRow});
  }


  AdjustCeiling(dir){
		let newFloor = Number(this.state.LowerFlood)
		let newCeiling = Number(this.state.UpperFlood)
		switch (dir){
			case 'UP':
				if (this.state.FloodMax >= newCeiling + this.state.FloodIncrement){
					newCeiling += this.state.FloodIncrement;
				}
				break;
			case 'DOWN':
				if (this.state.FloodMin <= newCeiling - this.state.FloodIncrement){
					if (newFloor === newCeiling){
						newFloor -= this.state.FloodIncrement;
					}
					newCeiling -= this.state.FloodIncrement;
				}
				break;
		}
		if (this.state.MatrixHeader.indexOf('Correlation') >= 0 || this.state.MatrixHeader.indexOf('TFIDF') >= 0){
			newCeiling = newCeiling.toFixed(2);
			newFloor = newFloor.toFixed(2);
		}
		this.setState({
			LowerFlood: newFloor,
			UpperFlood: newCeiling
		})
  }
  AdjustFloor(dir){
		let newFloor = Number(this.state.LowerFlood)
		let newCeiling = Number(this.state.UpperFlood)
		switch (dir){
			case 'UP':
			if (this.state.FloodMax >= newFloor + this.state.FloodIncrement){
				if (newFloor === newCeiling){
				newCeiling += this.state.FloodIncrement;
				}
				newFloor += this.state.FloodIncrement;
			}
			break;
			case 'DOWN':
			if (this.state.FloodMin <= newFloor - this.state.FloodIncrement){
				newFloor -= this.state.FloodIncrement;
			}
			break;
		} 
		if (this.state.MatrixHeader.indexOf('Correlation') >= 0 || this.state.MatrixHeader.indexOf('TFIDF') >= 0){
			newCeiling = newCeiling.toFixed(2);
			newFloor = newFloor.toFixed(2);
		}
		this.setState({
			LowerFlood: newFloor,
			UpperFlood: newCeiling
		})
  }
}

function sortObject(obj, propMatch, order) {
  var arr = [];
  for (var prop in obj) {
	  if (obj.hasOwnProperty(prop)) {
		if (prop.search(propMatch) >= 0){
			arr.push({
			  'key': prop,
			  'value': obj[prop]
			});
		}
	  }
  }
  var NotANumber = isNaN(arr[0].value);
  arr.sort(function(a, b) {
	if (NotANumber){
	  return ((order === 'desc') ? a.value[0].localeCompare(b.value) : b.value[0].localeCompare(a.value) );
	}
	else {
	  return ((order === 'desc') ? b.value - a.value : a.value - b.value);
	}
  });
  let sortOrder = arr.map(function(key, index){
	return key.key.slice(5);
  })
  return sortOrder; // returns array
}

function sortObjectColumn(obj, propMatch, order, parseType) {
  var arr = [];
  for (var Row in obj) {
	var matched = false;
	if (obj.hasOwnProperty(Row)) {
	  if (Row === "RowLabels" || Row === "ColLabels") {
	  }
	  else{
		for (var Column in obj[Row]){
		  if (obj[Row].hasOwnProperty(Column)) {
			if (Column === propMatch){
				arr.push({
				  'key': Row,
				  'value': obj[Row][Column]
				})
			  matched = true;
			}
		  }
		}
		if (matched === false) {
		  arr.push({
			'key': Row,
			'value': 0
		  })
		}
	  }
	}
  }
  var NotANumber = isNaN(arr[0].value);
  arr.sort(function(a, b) {
	if (NotANumber){
	  return ((order === 'desc') ? a.value.localeCompare(b.value) : b.value.localeCompare(a.value) );
	}
	else {
	  return ((order === 'desc') ? b.value - a.value : a.value - b.value);
	}
  });
  //arr.sort(function(a, b) { a.value.toLowerCase().localeCompare(b.value.toLowerCase()); }); //use this to sort as strings
  let sortOrder = arr.map(function(key){
	return key.key.slice(1);
  })
  return sortOrder; // returns array
}

function sortObjectRow(obj, propMatch, order, parseType, colCount) {
  var total_columns = colCount - 3
  var arr = [];
  for (var Row in obj) {
	var matched = false;
	if (obj.hasOwnProperty(Row)) {
	  if (Row === "RowLabels" || Row === "ColLabels") {
	  }
	  else if (Row === propMatch){
		for (var i=0; i<total_columns; i++){
		  if (obj[Row].hasOwnProperty("C" + i)) {
			  arr.push({
				'key': "C" + i,
				'value': obj[Row]["C" + i]
			  })
		  }
		  else {
			arr.push({
			  'key': "C" + i,
			  'value': 0
			})
		  }
		}
	  }
	}
  }
  var NotANumber = isNaN(arr[0].value);
  arr.sort(function(a, b) {
	if (NotANumber){
	  return ((order === 'desc') ? a.value.localeCompare(b.value) : b.value.localeCompare(a.value) );
	}
	else {
	  return ((order === 'desc') ? b.value - a.value : a.value - b.value);
	}
  });
  //arr.sort(function(a, b) { a.value.toLowerCase().localeCompare(b.value.toLowerCase()); }); //use this to sort as strings
  let sortOrder = arr.map(function(key, index){
	return key.key.slice(1);
  })
  return sortOrder; // returns array
}
function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
		return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
}